import { render, staticRenderFns } from "./MediaSection.vue?vue&type=template&id=48caf625&scoped=true&"
import script from "./MediaSection.vue?vue&type=script&lang=js&"
export * from "./MediaSection.vue?vue&type=script&lang=js&"
import style0 from "./MediaSection.vue?vue&type=style&index=0&id=48caf625&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48caf625",
  null
  
)

export default component.exports